export const requestPath = {
  resource: "resource/fg",
  resource1: "resource1/fg",
  sysuser1: "sysuser1/fg",
  sysuser: "sysuser/fg",
  order: "order/fg",
  third: "third",
  order1: "order1/fg",
  member: "member/fg",
  live: "live/fg",
  file: "file"
};
// file路径
export const codeUrl = process.env.BASE_API;
export const otherImageUrl = process.env.BASE_API + "/file/file/";
export const imageUrl = process.env.BASE_API + `/file1/file/`;
export const liveImg = process.env.BASE_API + `/file/`;
export const imgUrl = process.env.BASE_API + "/";
export const liveurl = "https://live.vhall.com/webinar/inituser/";
export const downloadPath = "download";
export const uploadPath = "upload";
export const filePath = process.env.BASE_API + '/file/file/?fileName='


// WEBPACK FOOTER //
// ./src/utils/global.js